import {IFilterFunction} from "angular";
import {languageName, TranslationsLanguage} from "../../config/TranslationsLanguage";

export const LanguageNamePipe = "tfLanguageName";

export function languageNamePipe(): IFilterFunction {
    return (language: TranslationsLanguage | null) => {
        if (language == null) {
            return null;
        } else {
            return languageName(language);
        }
    };
}
